<template>
  <van-col style="width: 100%; background-color: #F0F4FF;">
    <div class="fixed-header">
      <div class="enterprise-title">
        <div class="back-icon" @click="goBack">
          <span class="back-arrow"></span>
        </div>
        <div class="enterprise-text">消息管理</div>
      </div>

      <van-tabs v-model="activeTab" @change="handleTabChange" color="#176FCA">
        <van-tab title="未读">
        </van-tab>
        <van-tab title="已读">
        </van-tab>
      </van-tabs>

      <!-- 人员筛选下拉菜单（仅管理员可见） -->
      <div v-if="duty === 3 || duty === 99" class="staff-search-wrapper">
      <div class="staff-select" @click="showStaffPopup = true">
        <span>{{ getSelectedStaffText }}</span>
        <van-icon name="arrow-down" size="16px" color="#999" />
      </div>
      <van-popup v-model="showStaffPopup" position="bottom" round class="staff-popup">
        <div class="popup-header">
          <h3>选择人员</h3>
          <van-icon name="cross" size="20px" @click="showStaffPopup = false" />
        </div>
        <div class="popup-list">
          <div v-for="item in staffOptions" :key="item.id" class="popup-item" @click="selectStaff(item)">
            <span class="popup-item-text">{{ item.name }}</span>
            <van-icon name="arrow" size="16px" color="#999" />
          </div>
          <div v-if="staffOptions.length === 0" class="popup-empty">暂无人员数据</div>
        </div>
      </van-popup>
    </div>
    </div>

    <div class="content-wrapper" :class="{ 'with-staff-filter': duty === 3 || duty === 99 }">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" style="margin-bottom: 80px;">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :immediate-check=false>
        <template #default>
          <div v-for="(item, index) in messageList" :key="item.id || index" class="enterprise-card" @click="handleItem(item)">

            <div class="enterprise-card-content">
              <div class="enterprise-card-row">
                <div class="enterprise-card-label">标题</div>
                <div class="enterprise-card-value">{{ item.title }}</div>
              </div>
              <div class="enterprise-card-row">
                <div class="enterprise-card-label">内容</div>
                <div class="enterprise-card-value">{{ item.content }}</div>
              </div>
              <div class="enterprise-card-row">
                <div class="enterprise-card-label">时间</div>
                <div class="enterprise-card-value">{{ formatTime(item.createTime) }}</div>
              </div>
              <div class="enterprise-card-row" v-if="duty === 3 || duty === 99">
                <div class="enterprise-card-label">接收人</div>
                <div class="enterprise-card-value">{{ item.receiverName }}</div>
              </div>
            </div>

            <div class="enterprise-card-action-wrap">
              <div v-if="!item.isRead" class="unread-dot"></div>
              <div class="enterprise-card-action">
                <van-icon name="edit" color="#176FCA" />
              </div>
            </div>
          </div>

          <!-- 空状态 -->
          <div v-if="messageList.length === 0 && !loading" class="empty-state">
            <van-icon name="bell" size="64px" color="#c8c9cc" />
            <p class="empty-text">暂无消息</p>
          </div>
        </template>
      </van-list>
    </van-pull-refresh>
    </div>

    <!-- 客户编辑对话框 -->
    <CustomerEditDialog 
      :visible="showEditDialog"
      :is-adding="isAdding"
      :client-id="currentClientId"
      :message-id="currentMessageId"
      :loan-type="-1"
      @submit-success="onRefresh"
      @refresh="onRefresh"
      @message-read="handleMessageRead"
      @update:visible="val => showEditDialog = val"
    />

    <!-- 按钮行 -->
    <div class="button-row">
      <div 
        class="home-button" 
        @click="goToHome"
      >
        <van-icon name="wap-home" size="16" />
      </div>
    </div>

  </van-col>
</template>

<script>
import user from '@/utils/user'
import request from "@/utils/request";
import { Toast } from 'vant';
import CustomerEditDialog from '@/components/CustomerEditDialog.vue';

export default {
  name: 'MessageManage',
  components: {
    CustomerEditDialog
  },
  data() {
    return {
      duty: -1,
      activeTab: 0, // 0: 未读, 1: 已读
      messageList: [],
      loading: false,
      finished: false,
      refreshing: false,
      listQuery: {
        pageInfo: {
          pageSize: 10,
          page: 1,
          totalCount: 0
        },
        orderBy: "createTime",
        orderAsc: false,
        isRead: false,
        employeeId: null
      },
      // 人员筛选相关
      staffOptions: [],
      showStaffPopup: false,
      staffLoading: false,
      staffFinished: false,
      // 客户编辑对话框相关
      showEditDialog: false,
      isAdding: false,
      currentClientId: '',
      currentMessageId: '',
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.scrollTo(0, 0);
    });
  },
  computed: {
    // 计算是否正在操作中
    isOperating() {
      return this.loading || this.refreshing;
    },
    // 获取选中的人员文本
    getSelectedStaffText() {
      if (this.listQuery.employeeId === null) {
        return '请选择人员';
      }
      const selectedOption = this.staffOptions.find(option => option.id === this.listQuery.employeeId);
      return selectedOption ? selectedOption.name : '请选择人员';
    }
  },
  created() {
    this.duty = user.getUserDuty()
    this.listQuery.isRead = this.activeTab === 1
    // 管理员加载人员列表
    if (this.duty === 3 || this.duty === 99) {
      this.getStaffList();
    }
    this.onLoad();
  },
  methods: {
    // 处理标签切换
    handleTabChange(tabIndex) {
      this.activeTab = tabIndex;
      this.listQuery.isRead = tabIndex === 1;
      this.onRefresh();
    },

    // 处理消息点击
    handleItem(item) {
      // 打开编辑对话框
      this.isAdding = false;
      this.currentClientId = item.sourceId;
      this.currentMessageId = item.id;
      this.showEditDialog = true;
    },

    // 格式化时间
    formatTime(time) {
      if (!time) return '';
      const date = new Date(time);
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    },

    // 加载消息列表
    onLoad() {
      if (this.refreshing) {
        this.messageList = [];
        this.listQuery.pageInfo.page = 1;
      }

      var filterForm = Object.assign({}, this.listQuery);

      request.post('/Common/Message/QueryMyMessages', filterForm)
        .then((res) => {
          if (res.data && res.data.data) {
            const dataList = res.data.data.data || [];
            this.listQuery.pageInfo.page = res.data.data.pageInfo.page + 1;
            this.messageList = this.messageList.concat(dataList);
            // 根据返回数据数量判断是否还有更多数据
            this.finished = !res.data.data.pageInfo.hasMore
          } else {
            this.finished = true;
          }
          this.loading = false;
          this.refreshing = false;
        }).catch((error) => {
          console.error('加载消息列表失败:', error);
          Toast('加载失败，请重试');
          this.loading = false;
          this.refreshing = false;
          this.finished = true;
        });
    },

    // 刷新消息列表
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.refreshing = true;
      this.onLoad();
    },

    // 获取人员列表
    getStaffList() {
      request.get('/User/Department/GetStaffList')
        .then((res) => {
          if (res.data && res.data.data) {
            this.staffOptions = res.data.data;
          }
        })
        .catch((error) => {
          console.error('获取人员列表失败:', error);
          Toast('获取人员列表失败，请重试');
        });
    },

    // 选择人员
    selectStaff(item) {
      this.listQuery.employeeId = item.id;
      this.showStaffPopup = false;
      this.onRefresh();
    },

    // 加载人员列表
    onLoadStaff() {
      // 这里可以添加分页加载逻辑
      this.staffFinished = true;
      this.staffLoading = false;
    },
    // 返回首页
    goToHome() {
      this.$router.push("/credit/home");
    },
    // 返回上一页
    goBack() {
      this.$router.back();
    },

    // 局部更新消息已读状态
    handleMessageRead(messageId) {
      const item = this.messageList.find(msg => msg.id === messageId);
      if (item) {
        item.isRead = true;
      }
    },
  }
};
</script>

<style lang="less" scoped>
.fixed-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background-color: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.enterprise-title {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  padding: 12px;
  width: 100%;
  box-sizing: border-box;
  position: relative;
}

.content-wrapper {
  padding-top: 92px;
  background-color: #F0F4FF;
  min-height: calc(100vh - 92px);
}

.content-wrapper.with-staff-filter {
  padding-top: 150px;
  min-height: calc(100vh - 150px);
}

/* van-tabs 样式 */
.fixed-header .van-tabs {
  background-color: #ffffff !important;
}

.fixed-header .van-tabs__nav {
  background-color: #ffffff !important;
}

.fixed-header .van-tabs__wrap {
  height: 44px;
}

.fixed-header .van-tab {
  background-color: #ffffff;
}

.back-icon {
  cursor: pointer;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  margin-right: 12px;
}

.back-arrow {
  display: inline-block !important;
  width: 10px;
  height: 10px;
  border-left: 2px solid #333;
  border-bottom: 2px solid #333;
  transform: rotate(45deg);
  margin-right: 4px;
  visibility: visible !important;
  opacity: 1 !important;
}

.enterprise-text {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size: 18px;
  font-weight: 500;
}

.enterprise-card {
  margin: 12px 16px 0;
  padding: 16px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: box-shadow 0.3s;
}

.enterprise-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.enterprise-card-action-wrap {
  flex-shrink: 0;
  margin-left: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.enterprise-card-action {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background-color: #EDF3FA;
  border-radius: 12px;
}

.enterprise-card-content {
  flex: 1;
  min-width: 0;
}

.enterprise-card-row {
  display: flex;
  margin-bottom: 12px;
  align-items: center;
}

.enterprise-card-row:last-child {
  margin-bottom: 0;
}

.enterprise-card-label {
  width: 80px;
  color: #666;
  font-size: 14px;
  flex-shrink: 0;
}

.enterprise-card-value {
  color: #333;
  font-size: 14px;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.button-row {
  position: fixed;
  bottom: 20px;
  left: 16px;
  right: 16px;
  padding: 10px 0;
  display: flex;
  align-items: center;
  gap: 12px;
  z-index: 999;
  justify-content: flex-end;
}

.home-button {
  width: 44px;
  height: 44px;
  background-color: #176FCA;
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  transition: background-color 0.3s;
  flex-shrink: 0;
}

.home-button:hover {
  background-color: #145EAB;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 90vh;
  justify-content: center;
  text-align: center;
}

.empty-text {
  margin-top: 16px;
  color: #999;
  font-size: 14px;
}

.staff-search-wrapper {
  padding: 12px 12px;
  background: #FFFFFF;
}

.staff-select {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: #F5F7FF;
  border: 1px solid #E3E8F5;
  border-radius: 12px;
  cursor: pointer;
}

.staff-select:hover {
  border-color: #3a71ff;
  box-shadow: 0 2px 12px 0 rgba(58, 113, 255, 0.1);
}

.staff-select span {
  font-size: 0.9rem;
  color: #333;
}

.staff-popup {
  max-height: 80vh;
}

.popup-list {
  max-height: calc(80vh - 52px);
  overflow-y: auto;
}

.popup-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background 0.2s;
}

.popup-item:last-child {
  border-bottom: none;
}

.popup-item:active {
  background: #f5f7ff;
}

.popup-item-text {
  font-size: 14px;
  color: #333;
}

.popup-empty {
  padding: 40px 16px;
  text-align: center;
  color: #999;
  font-size: 14px;
}

.popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-bottom: 1px solid #e4e7ed;
}

.popup-header h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: bold;
  color: #333;
}

.popup-header .van-icon {
  cursor: pointer;
  color: #999;
}

.popup-header .van-icon:hover {
  color: #333;
}

.unread-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #ff4444;
}
</style>